export const ZVA_START = 'chatbot/ZVA_START'
export const ZVA_LOADING = 'chatbot/ZVA_LOADING'
export const ZVA_OPEN = 'chatbot/ZVA_OPEN'
export const ZVA_INITIALIZED = 'chatbot/ZVA_INITIALIZED'
export const ZVA_UPDATED = 'chatbot/ZVA_UPDATED'
export const ZVA_FAILED = 'chatbot/ZVA_FAILED'
export const SIERRA_START = 'chatbot/SIERRA_START'
export const SIERRA_LOADING = 'chatbot/SIERRA_LOADING'
export const SIERRA_OPEN = 'chatbot/SIERRA_OPEN'
export const SIERRA_INITIALIZED = 'chatbot/SIERRA_INITIALIZED'
export const SIERRA_UPDATED = 'chatbot/SIERRA_UPDATED'
export const SIERRA_FAILED = 'chatbot/SIERRA_FAILED'

export type ZvaStartAction = {
  type: 'chatbot/ZVA_START'
}
export type ZvaLoadingAction = {
  type: 'chatbot/ZVA_LOADING'
}
export type ZvaOpenAction = {
  type: 'chatbot/ZVA_OPEN'
}
export type ZvaInitializedAction = {
  type: 'chatbot/ZVA_INITIALIZED'
}
export type ZvaUpdatedAction = {
  type: 'chatbot/ZVA_UPDATED'
}
export type ZvaFailedAction = {
  type: 'chatbot/ZVA_FAILED'
  error: Error
}
export type SierraStartAction = {
  type: 'chatbot/SIERRA_START'
}
export type SierraLoadingAction = {
  type: 'chatbot/SIERRA_LOADING'
}
export type SierraOpenAction = {
  type: 'chatbot/SIERRA_OPEN'
}
export type SierraInitializedAction = {
  type: 'chatbot/SIERRA_INITIALIZED'
}
export type SierraUpdatedAction = {
  type: 'chatbot/SIERRA_UPDATED'
}
export type SierraFailedAction = {
  type: 'chatbot/SIERRA_FAILED'
  error: Error
}

export type ChatbotAction =
  | ZvaStartAction
  | ZvaLoadingAction
  | ZvaOpenAction
  | ZvaInitializedAction
  | ZvaUpdatedAction
  | ZvaFailedAction
  | SierraStartAction
  | SierraLoadingAction
  | SierraOpenAction
  | SierraInitializedAction
  | SierraUpdatedAction
  | SierraFailedAction
